import api, { unwrapSingle } from "@/lib/api";

let cachedCatalog = null;
let inFlightCatalogRequest = null;

function normalizeCatalog(raw = {}) {
  return {
    permissions: Array.isArray(raw.permissions) ? raw.permissions : [],
    org_types: Array.isArray(raw.org_types) ? raw.org_types : [],
    fixed_capabilities: Array.isArray(raw.fixed_capabilities) ? raw.fixed_capabilities : [],
  };
}

export async function fetchRbacCatalog({ force = false } = {}) {
  if (!force && cachedCatalog) return cachedCatalog;
  if (!force && inFlightCatalogRequest) return inFlightCatalogRequest;

  inFlightCatalogRequest = api
    .get("/rbac/catalog")
    .then((response) => {
      const payload = unwrapSingle(response) || {};
      const normalized = normalizeCatalog(payload);
      cachedCatalog = normalized;
      return normalized;
    })
    .finally(() => {
      inFlightCatalogRequest = null;
    });

  return inFlightCatalogRequest;
}

export function getCachedRbacCatalog() {
  return cachedCatalog;
}

export function clearRbacCatalogCache() {
  cachedCatalog = null;
  inFlightCatalogRequest = null;
}

export function getOrgTypeConfig(catalog, orgType) {
  const source = catalog || cachedCatalog || {};
  const orgTypes = Array.isArray(source.org_types) ? source.org_types : [];
  const found = orgTypes.find((entry) => entry?.org_type === orgType);

  if (!found) {
    return {
      customizable: false,
      grantable: [],
      roles: [],
    };
  }

  return {
    customizable: Boolean(found.customizable),
    grantable: Array.isArray(found.grantable) ? found.grantable : [],
    roles: Array.isArray(found.roles) ? found.roles : [],
  };
}
